import React from 'react';
import { cRoot, passportRoot } from '@liepin/js-core4c-fe';
import domain from '@liepin/native-domain-fe';
import { Menu } from 'antd';
import { ERouterMap } from '../../../types';

const LogoutKeepCurrentPage = new Set([
  '/campus/',
  '/campus/xycomps/',
  '/campus/recruit-list/',
  '/campus/live-list/',
  '/campus/campus-detail/',
]);

const QuickMenuSubMenu: React.FC = () => {
  let backURL = '';
  let pathName = window.location?.pathname;
  const lastWord = window.location?.pathname.slice(-1);
  if (lastWord !== '/') {
    pathName = `${pathName}/`;
  }

  if (LogoutKeepCurrentPage.has(pathName) || pathName.includes('/campus/campus-detail/')) {
    backURL = window.location?.href;
  }
  return (
    <Menu>
      <Menu.Item key="header-quick-menu-resume">
        <a
          id="header-quick-menu-resume"
          href={`${cRoot}${ERouterMap.ResumeDefault}`}
        >
          我的简历
        </a>
      </Menu.Item>
      <Menu.Item key="header-quick-menu-applyelist">
        <a
          id="header-quick-menu-applyelist"
          href={`${cRoot}${ERouterMap.ApplyList}`}
        >
          我的投递
        </a>
      </Menu.Item>
      <Menu.Item key="header-quick-menu-favoritesjob">
        <a
          id="header-quick-menu-favoritesjob"
          href={`${cRoot}${ERouterMap.FavoriteJob}`}
        >
          我的收藏
        </a>
      </Menu.Item>
      <Menu.Item key="header-quick-menu-profile-getsecret">
        <a
          id="header-quick-menu-profile-getsecret"
          href={`${domain('account')}${ERouterMap.ProfileSecret}?key=whoCheckMyResume`}
        >
          隐私设置
        </a>
      </Menu.Item>
      <Menu.Item key="header-quick-menu-account-secret">
        <a
          id="header-quick-menu-account-secret"
          href={`${domain('account')}${ERouterMap.ProfileSecret}?key=modifyPhone`}
        >
          账号安全
        </a>
      </Menu.Item>
      <Menu.Item key="header-quick-menu-logout">
        <a
          id="header-quick-menu-logout"
          href={`${passportRoot}/v1/logout?backurl=${backURL}`}
        >
          退出登录
        </a>
      </Menu.Item>
    </Menu>
  );
};

export default QuickMenuSubMenu;
